import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="profile-edit"
export default class extends Controller {
  static targets = ["viewMode", "editMode", "editButtonText"]

  connect() {
    this.isEditing = false
  }

  toggleEdit(event) {
    event.preventDefault()
    this.isEditing = !this.isEditing

    if (this.isEditing) {
      this.showEditMode()
    } else {
      this.showViewMode()
    }
  }

  cancel(event) {
    event.preventDefault()
    this.isEditing = false
    this.showViewMode()
  }

  showEditMode() {
    // Hide all view mode elements
    this.viewModeTargets.forEach(element => {
      element.classList.add("hidden")
    })

    // Show edit mode
    this.editModeTargets.forEach(element => {
      element.classList.remove("hidden")
    })

    // Update button text
    if (this.hasEditButtonTextTarget) {
      const cancelText = this.element.dataset.cancelText || "Annuler"
      this.editButtonTextTarget.textContent = cancelText
    }
  }

  showViewMode() {
    // Show all view mode elements
    this.viewModeTargets.forEach(element => {
      element.classList.remove("hidden")
    })

    // Hide edit mode
    this.editModeTargets.forEach(element => {
      element.classList.add("hidden")
    })

    // Update button text
    if (this.hasEditButtonTextTarget) {
      // Get the text from I18n or use default
      const editText = this.element.dataset.editText || "Éditer le profil"
      this.editButtonTextTarget.textContent = editText
    }
  }
}
